export const UserRoles = {
    ADMIN: "s",
    OWNER: "so",
    READER: "r",
    WRITER: "w",
    BACKOFFICE: "bo",
    PP_SUPPORT: "ppsu",
    SUPPORT: "su"
}